(function() { 
    /* 
     * Declaracion del controlador para la vista de detalles
     */
    angular.module('ngmvac').controller('detailsController', DetailsController);
    /*
     * Inyeccion de depencias en el controlador
     */
    DetailsController.$inject = ['$window', '$document', '$scope', '$filter', '$timeout', 'HotelFactory', 'ContentApiService', 'Cart', 'DatosCotizador', 'timeService', '$sce', 'CurrencyDictionary','fontNames', '$log', '$timeout'];
    /**
     * Definicion del Controlador
     * @constructor
     * @param {object} $window - wrapper del objeto Window de angular.
     * @param {object} $document - wrapper del objeto Document de angular.
     * @param {object} $scope - servicio scope de angular.
     * @param {object} $filter - servicio filter de angular.
     * @param {object} $timeout - servicio timeout de angular.
     * @param {object} HotelFactory - servicio de datos para disponibilidad hoteles.
     * @param {object} ContentApiService - servicio de datos para contenido hoteles.
     * @param {object} Cart - servicio de datos para carito de compras.
     * @param {object} TimeService - servicio para tiempo de inactividad.
     * @param {object} sce - servicio para sanado de html.
     * @param {object} CurrencyDictionary - Provider de tipo value para tipo de moneda.
     * @param {object} Diccionario de iconos de las facilidades.
     */
    function DetailsController($window, $document, $scope, $filter, $timeout, HotelFactory, ContentApiService, Cart, DatosCotizador, timeService, sce, CurrencyDictionary, fontNames, $log,$timeout) {
    
        var vm                  = this;
        vm.cotizadorSeleccionado = localStorage.getItem('cotizadorSeleccionado');
        vm.pathImagesNormal     = 'https://photos.hotelbeds.com/giata';
        vm.pathImages           = 'https://photos.hotelbeds.com/giata/bigger';
        vm.pathImagesMini       = 'https://photos.hotelbeds.com/giata/small';
        vm.hotel                = {};
        vm.CaroucelMovil        = [];
        vm.SelectTemporalRoom   = '';
        vm.cotizador            = {}; // Readonly
        vm.step                 = 3;
        vm.adults               = 0;
        vm.children             = 0;
        vm.rooms                = 0;
        vm.totalNoches          = 0;
        vm.showMapa             = false;
        vm.showModal            = false;
        vm.roomShowing          = {};
        vm.timeExpired          = false;
        vm.packAuto             = false;
        vm.Instalacionesyserv   = true;
        vm.recotizar            = false;
        vm.pricesLoaded         = false;
        vm.checkAvailability    = true;
        vm.longitude = 0;
        vm.latitude = 0;
        vm.roomStayFacilities = "";
        vm.m2 = "";
        vm.fasPrimaryFront = "";
        vm.imgMainBanner = [];
        vm.codesImages = [];
        vm.autoAdapter = {};

        vm.initialStay = {
            checkIn: moment().add(4, 'days').format('YYYY-MM-DD'),
            checkOut: moment().add(7, 'days').format('YYYY-MM-DD')
        };
        vm.Drooms = {};
        vm.DetailsRoom = {};

        vm.backToTop = function() {
            $('body,html').animate({
                scrollTop: 0
            }, 500);
            return false;
        }

        vm.datosCotizacion = {
            search: {},
            cart: [],
            client: {}   
        };
        vm.clienteCotizacion = {};
        vm.validacionCotizacion = {
            name: false,
            surname: false,
            email: false,
            phone: false,
            cellphone: false
        };
        vm.cotizacionBtn = 'Guardar y enviar cotización';
        vm.sendQuotation = {
            msg: '',
            error: false
        };
        vm.showQuotationMesssage = false;
        vm.urlEnviaCotizacion = '';
        vm.claveInternacional = 122;
        vm.agente = 41;

        vm.enviaCotizacion = (localStorage.getItem('uidFenix') != null) ? true : false;
        vm.isShowingFullDescription = false;
        vm.imgPattern = /^\/.+$/;

        vm.quoteToggle = function() {
            $('body').toggleClass('bg-gray-1');
            $('.Navbar__container').toggleClass('d-none d-lg-block');
            $('#nav-habitacion').toggleClass('d-none d-lg-block');
            $('#nav-habitacines-menu').toggleClass('d-none d-lg-block');
            $('#quote').toggleClass('d-none d-lg-block');
            $('#contDescripcion').toggleClass('d-none d-md-block');
            $('#textHabitaciones').toggleClass('d-none d-md-block');
            $('#paquetes').toggleClass('d-block d-sm-none d-none d-md-block');
            $('#contInformacion').toggleClass('d-none d-md-block');
            $('#toolboxdet').toggleClass('d-block d-sm-none d-none d-md-block');
        }

        vm.returnlist = function(){
            localStorage.setItem('page', 'detalles');         
            $window.location.href = "/hotelv2";
            localStorage.removeItem('hotelSelected');
        }
        
        vm.reloadRoute = function(){
            // console.log("funciona!")
            $window.location.reload()
        }

        var getQueryStringValue = function (name, url) {
            name = name.replace(/[\[]/, "\\[").replace(/[\]]/, "\\]");
            var regex = new RegExp("[\\?&]" + name + "=([^&#]*)"),
            results = regex.exec(url);
            return results === null ? "" : decodeURIComponent(results[1].replace(/\+/g, " "));
        }

        $scope.imgError = function(el) {
            $(el).parent().remove();
        }

        var pathname = $window.location.pathname;
        var pathnameArr = pathname.split('/');
        var flt = getQueryStringValue('flt', $window.location.search);
        
        vm.tipo_habi = flt;

        timeService.init({
            end: function() {
                vm.timeExpired = true;
            },
            limit: 10
        });

        $scope.cotizador  = false;
        $scope.data       = false;
        $scope.content    = false;
        $scope.loadComplete = false;

        $scope.$watchGroup(['cotizador', 'data', 'content'], function(newValues){
            
            if(newValues[2]){
                
                $.HSCore.components.HSGoTo.init('.js-go-to');
            $(".footer-base").addClass("d-sm-block");
            $(".footer-base").show();

            buttons = $("#buttonsGallery").html();
            imgsFancy = [];
            angular.forEach(vm.hotel.content.images, function(img){
                if(angular.isDefined (img.type) == false){
                    var description = ""
                }else{
                    var description = img.type.description.content;
                }
                imgsFancy.push({
                    src: vm.pathImages+'/'+img.path,
                    filterSelf: description,
                    opts: {
                        thumb: vm.pathImages + '/' + img.path
                    }
                });
            });

            configOptions = {
                buttons: [
                    'slideShow',
                    'fullScreen',
                    'thumbs',
                    'close'
                ],
                baseTpl:
                    '<div class="fancybox-container nicosli" role="dialog" tabindex="-1">' +
                    '<div class="fancybox-bg"></div>' +
                    '<div class="fancybox-inner">' +
                    '<div class="fancybox-infobar"><span data-fancybox-index></span>&nbsp;/&nbsp;<span data-fancybox-count></span></div>' +
                    '<div class="fancy-tags">' +
                    //buttons +
                    '</div>' +
                    '<div class="fancybox-toolbar">{{buttons}}</div>' +
                    '<div class="fancybox-navigation">{{arrows}}</div>' +
                    '<div class="fancybox-stage"></div>' +
                    '<div class="fancybox-caption"><div class=""fancybox-caption__body"></div></div>' +
                    '</div>' +
                    '</div>',
                thumbs: {
                    autoStart: true
                },
                afterLoad: function(instance, current){
                    $(".btn-filter").on("click", function(){
                        var elements = $(".fancybox-thumbs__list > a");
                        filter = this.getAttribute('data-value'); //boton usuario click
                        // $.each(elements, function(key, val){
                        //     $.each(imgsFancy, function(imgIndex, img){
                        //         if (imgsFancy != filter){
                        //             val.style.display = "none";
                        //         }else{
                        //             console.log(img.filterSelf, filter);
                        //         }
                        //     });
                        // });
                    });
                }
            };

            $("#openGallery").on("click", function(){
                $.fancybox.open(imgsFancy, configOptions);
            });
            
            $('[data-fancybox="gallery"]').fancybox(configOptions);
            
                
            }
            if( newValues[0] && newValues[1] && newValues[2] ){
                $scope.loadComplete = true;
            }
        });


        imageExists = function(url){
            return new Promise(resolve => {
                var image = new Image();
        
                image.src = url;
                // console.log(image.onerror, url);
            
                // if (!image.complete) {
                //     return false;
                // }
                // ima.o
                image.onload = function(){
                    // console.log(image.height, "height");

                // image  has been loaded.
                    if (image.height === 0) {
                        resolve(false);
                    }
                
                    resolve(true);
                };

                image.onerror = function(){
                    resolve(false);
                }
                
            })
            
        }

        vm.loadMainImages = async function(images) {

                  // angular.forEach(vm.hotel.content.images, function(img) {
                    var codesItems = [];
                    for (var index = 0; index < images.length; index++) {
                    // (async function(index, codesItems) {
                        
                
                        const img = images[index];
                            
                        // }
                        // if(vm.imgMainBanner.length == 6) {
                        //     break;
                        // }

                        // console.log(img, "img");
        
                        typecode = img.hasOwnProperty('type') ? img.type.code : img.imageTypeCode;
        
                        // let notExistImg = false;
                        
                        if(!codesItems.includes(typecode)) {
                            vm.pathImages = (typecode == 'DEFAULT') ? 'https://mexicovacations.com.mx/' : vm.pathImages;
                            let notExistImg = await imageExists(((typecode == 'DEFAULT') ? 'https://mexicovacations.com.mx/' : 'https://photos.hotelbeds.com/giata/bigger/') + img.path);
                                //console.log(notExistImg, "notExist");

                                if(notExistImg) {
                                    if (typecode == 'HAB' 
                                        && codesItems.find(element => element === 'HAB') !== 'HAB') {
                                        vm.imgMainBanner.push(img);
                                        codesItems.push('HAB');
                                    }
                                    if (typecode == 'RES' 
                                        && codesItems.find(element => element === 'RES') !== 'RES') {
                                        vm.imgMainBanner.push(img);
                                        codesItems.push('RES');
                                    }
                                    if (typecode == 'PIS' 
                                        && codesItems.find(element => element === 'PIS') !== 'PIS') {
                                        vm.imgMainBanner.push(img);
                                        codesItems.push('PIS');
                                    }
                                    if (typecode == 'TER' 
                                        && codesItems.find(element => element === 'TER') !== 'TER') {
                                        vm.imgMainBanner.push(img);
                                        codesItems.push('TER');
                                    }
                                    if (typecode == 'BAR' 
                                        && codesItems.find(element => element === 'BAR') !== 'BAR') {
                                        vm.imgMainBanner.push(img);
                                        codesItems.push('BAR');
                                    }
                                    if (typecode == 'CON' 
                                        && codesItems.find(element => element === 'CON') !== 'CON') {
                                        vm.imgMainBanner.push(img);
                                        codesItems.push('CON');
                                    }
                                    
                                    if (typecode == 'DEFAULT' 
                                        && codesItems.find(element => element === 'DEFAULT') !== 'DEFAULT') {
                                        vm.imgMainBanner.push(img);
                                        codesItems.push('DEFAULT');
                                    }
                                }
                            // });
                        }
                            // notExistImg = 
        
    

        
                    // }
                // })(index);
            }
        
    
        }

        /* Solicitar informacion del hotel seleccionado en lista de hoteles */
        search = HotelFactory.getCotizador();
        clavesInternacionales = [];
        HotelFactory.clavesInternacionales().then(function(response) {
            clavesInternacionales = response.data;
        });
        
        vm.pathImages           = 'https://photos.hotelbeds.com/giata/bigger';
        vm.pathImagesMini       = 'https://photos.hotelbeds.com/giata/small';
        vm.initializationData = search;      
        vm.totalNoches        = moment(search.stay.checkOut, 'YYYY-MM-DD').diff(moment(search.stay.checkIn, 'YYYY-MM-DD'), 'days');
        $scope.cotizador = true;
        vm.searchlocalStorage = JSON.parse(localStorage.getItem('search'));

        HotelFactory.obtenerHotel(pathnameArr[pathnameArr.length - 1], flt, search).then(function(response) {
            var data = response.data;

            vm.cotizador    = data.search;
            vm.hotel        = data.hotel;
            vm.search       = data.search;
            vm.hotel.clavesInternacionales = clavesInternacionales;
            var packageFiltered = "";
            if(angular.isDefined (vm.hotel)){
                angular.forEach(vm.hotel.packages, function(elements){
                    angular.forEach(elements, function(item){
                        if(packageFiltered == ""){
                            packageFiltered = item;
                        }
                    });
                });
                vm.hotel.packageFiltered = packageFiltered;
            }

            var filtroRegimen = $('#filtroReservacion').val(); //RodrigoS

            if(filtroRegimen !== "ALL"){
                if(angular.isDefined (vm.hotel)){
                    angular.forEach(vm.hotel.packages, function(elements){
                        angular.forEach(elements, function(item){
                            if(item.boardCode !== filtroRegimen)
                            {
                                elements.splice(0,elements.length);
                            }
                        });
                    });
                }
            }

            angular.forEach(vm.cotizador.occupancies, function(_value, _index) {
                vm.adults   += parseFloat(_value.adults) * parseFloat(_value.rooms);
                vm.rooms    += parseFloat(_value.rooms);
                vm.children += parseFloat(_value.children) * parseFloat(_value.rooms);
            });

            vm.loaderStyle = { display: 'none' };
            vm.pricesLoaded = true;
            codesItems = [];
            var roomsCodeForFacilitiesRequestInAvail = [];

            vm.loadMainImages(vm.hotel.content.images);
            // });

            // if (vm.imgMainBanner.length <= 6) {
            //     limite = 0;
            //     angular.forEach(vm.hotel.content.images, function (img) {
            //         typecode = img.hasOwnProperty('type') ? img.type.code : img.imageTypeCode;
            //         if ((typecode == 'GEN' || typecode == 'HAB') && limite <= (7 - vm.imgMainBanner.length)){
            //             vm.imgMainBanner.push(img);
            //             limite++;
            //         }
            //     });
            // }
            var tarifaBaja = false;
            var nuevoMinPackage = false;
            angular.forEach(vm.hotel.packages, function(item){
                for (var index = 0; index < item.length; index++) {
                    var element = item[index];
                    vm.CaroucelMovil.push(element);
                    for (var iRoom = 0; iRoom < element.rooms.length; iRoom++) {
                        if (roomsCodeForFacilitiesRequestInAvail.indexOf(element.rooms[iRoom].roomCode) === -1) {
                            roomsCodeForFacilitiesRequestInAvail.push(element.rooms[iRoom].roomCode);
                        }
                        var room = element.rooms[iRoom];
                        //room.images = [];


                        room.portada = '';
                        for (var iImage = 0; iImage < vm.hotel.content.images.length; iImage++) {
                            var image = vm.hotel.content.images[iImage];
                            if(image.imageTypeCode == 'HAB') {

                                if(room.roomCode == image.roomCode){
                                    //room.images.push(image);
                                    room.portada = image.path;
                                }
                                
                                if(!image.hasOwnProperty('roomCode')) {
                                    room.portada = image.path;
                                }
                                
                                if(room.portada == '') {
                                    let roomType= room.roomCode.substr(0, room.roomCode.indexOf('.'));
                                    console.log(roomType, "roomType");
                                    console.log(image.roomType, "roomTypeI");
                                     if(image.roomType == roomType) {
                                        room.portada = image.path;     
                                     }
                                }
                                
                                // if(room.portada != '') {
                                //     break;
                                // }
                            }
                            
                        }
                        if(filtroRegimen !== "ALL"){
                            if(tarifaBaja == false){
                                    nuevoMinPackage = true;
                                    tarifaBaja = true
                            }else{
                                if(vm.hotel.minPackage.price > item[index].price){
                                    nuevoMinPackage = true;
                                }else{
                                    nuevoMinPackage = false;
                                }
                            }
                            if(nuevoMinPackage){
                                vm.hotel.minPackage.avgPrice = item[index].avgPrice;
                                vm.hotel.minPackage.boardCode = item[index].boardCode;
                                vm.hotel.minPackage.boardName = item[index].boardName;
                                vm.hotel.minPackage.discountAmount = item[index].discountAmount;
                                vm.hotel.minPackage.net = item[index].net;
                                vm.hotel.minPackage.price = item[index].price;
                                vm.hotel.minPackage.rooms = item[index].rooms.length;
                            }
                        }
                    }
                }
            });

            vm.sliderimg  = [];
            vm.SelectTemporalRoom = vm.CaroucelMovil[0];
            var see = vm.CaroucelMovil.length -1;

            $timeout(function() {
                $('#SelectedPackage0').removeClass('border-secondary');
                $('#SelectedPackage0').addClass('border-primary');
                $('#SelectedPackage0').addClass('bordersoselect');
                $('#PackageSee'+see).css('min-width', '100%');
                $('#ButtonSelectedPackage0').html('Seleccionada');
                $('#ButtonSelectedPackage0').removeClass('btn-outline-secondary');
                $('#ButtonSelectedPackage0').addClass('btn-outline-primary');
            }, 2000);


            angular.forEach(vm.hotel.content.images, function (image) {
                vm.sliderimg.push((/^\/.+$/.test(image.path) ? image.path : '/' + image.path));

            });

            vm.latitude = vm.hotel.content.coordinates.latitude;
            vm.longitude = vm.hotel.content.coordinates.longitude;

            vm.lengthSlider= vm.sliderimg.length;
                //    ELIMINAR SI IMAGEN ES REPETIDA
            vm.NewArray=[];
            vm.primeroItem=true;

            angular.forEach(vm.sliderimg ,function(e) {
                if(vm.primeroItem == true){
                        vm.primeroItem=false;
                    vm.NewArray.push(e);
                }else{
                    var si=0;
                    angular.forEach(vm.NewArray,function(item) {
                        if(item == e){
                            si+=1;
                        }                            
                    });
                    if(si == 0){
                        vm.NewArray.push(e);
                    }
                }
            });
            vm.sliderimg=angular.copy(vm.NewArray);

            // ------
            console.log(vm.hotel, "hotel");

            vm.showMapa = true;
            $scope.content = true;
            $('#carousel-hotel').carousel();
            
            // ContentApiService.get(vm.hotel.code).then(function(response) {
            //     vm.Drooms = response.data.hotels[0];
            //     var fasPrimary = [];

            //     angular.forEach(response.data.hotels[0].facilities, function(fas){
            //         if (fas.hasOwnProperty('description')){
            //             if (fas.facilityCode == 261)
            //                 fasPrimary.push({
            //                     description: fas.description.content,
            //                     class: 'fas fa-wifi'
            //                 });
            //             if (fas.facilityCode == 200 && fas.facilityGroupCode == 71)
            //                 fasPrimary.push({
            //                     description: fas.description.content,
            //                     class: 'fas fa-utensils'
            //                 });
            //             if (fas.facilityCode == 470 && fas.facilityGroupCode == 70)
            //                 fasPrimary.push({
            //                     description: fas.description.content,
            //                     class: 'fas fa-dumbbell'
            //                 });
            //             if (fas.facilityCode == 320 && fas.facilityGroupCode == 70)
            //                 fasPrimary.push({
            //                     description: fas.description.content,
            //                     class: 'fas fa-parking'
            //                 });
            //         }
            //     });

            //     vm.fasPrimaryFront = fasPrimary;
            //     vm.hotel.content = response.data.hotels[0];
            //     itemAc = 0;
            //     vm.showMapa = true;
            //     $scope.content = true;
            //     $('#carousel-hotel').carousel();
            //     var roomsCodeForFacilitiesRequest = [];

            //     angular.forEach(roomsCodeForFacilitiesRequestInAvail, function (roomCodeFFRIA) {
            //         angular.forEach(vm.hotel.content.rooms, function (room) {
            //             if (room.roomCode === roomCodeFFRIA && (typeof room.roomFacilities !== 'undefined') 
            //                 && roomsCodeForFacilitiesRequest.indexOf(room.roomCode) === -1) {
            //                 roomsCodeForFacilitiesRequest.push({code: room.roomCode, facilities: room.roomFacilities});
            //             }    
            //         });
            //     }); 

            //     ContentApiService
            //     .getRoomFacilitiesFor(roomsCodeForFacilitiesRequest)
            //     .then(function(response) {
            //         angular.forEach(vm.hotel.packages, function(item){
            //             for (var index = 0; index < item.length; index++) {
            //                 var element = item[index];
            //                 for (var iRoom = 0; iRoom < element.rooms.length; iRoom++) {
            //                     angular.forEach(response.data, function(facilityDescription) {
            //                         if (facilityDescription.code == element.rooms[iRoom].roomCode) {
            //                             var validFacilities = [];
            //                             angular.forEach(facilityDescription.facilities, function (facility) {
            //                                 var insert = false;
                                            
            //                                 if (typeof facility.indYesOrNo !== 'undefined' && typeof facility.indLogic !== 'undefined') {
            //                                     insert = facility.indYesOrNo && facility.indLogic;
            //                                 } else if (typeof facility.indYesOrNo !== 'undefined') {
            //                                         insert = facility.indYesOrNo;
            //                                 } else if (typeof facility.indLogic !== 'undefined') {
            //                                     insert = facility.indLogic;
            //                                 } else {
            //                                     insert = false;
            //                                 }

            //                                 if (insert) {
            //                                     validFacilities.push(facility);
            //                                 }

            //                             });
            //                             element.rooms[iRoom].facilitiesDescription = validFacilities;
            //                         }
            //                     });
            //                 }
            //             }
            //         });
            //     })

            //     .catch(function(response) {
            //         $log.error(response.body);
            //     }); 

            // }).catch(function(err) {
            // });

        }).catch(function(err) {
            // $window.location.href = "/hotelv2"; 
            //RodrigoS
            // $log.error(err);
            // $('body').toggleClass('loaded-failed');
        });



        // vm.checkIfImgExist = function(url) {
        //     return new Promise(resolve => {
        //         var img = new Image();
        //         let exist = true;
        //         // img.onload = function() { callback(true); };
        //         img.onerror = function() { exist = false; };
        //         img.src = url;

        //         resolve(exist);
        //     })
            
        // }

        // vm.imageExist = async function(path) {
        //     let e = false;
        //     e = await vm.checkIfImgExist('https://photos.hotelbeds.com/giata/bigger/'+path);
        //     console.log(e, "e");
        //     return e;

            
        //     // let http = new XMLHttpRequest();
        //     // http.open('HEAD', 'https://photos.hotelbeds.com/giata/bigger/' + path, false);            
        //     // http.send();

        //     // return http.status != 404;

        // }
        

        vm.validateCotizacionForm = function () {
            if(vm.clienteCotizacion.name === ''){
                vm.validacionCotizacion.name = true;
                return false;
            }
            if(vm.clienteCotizacion.surname === ''){
                vm.validacionCotizacion.surname = true;
                return false;
            }
            if(vm.clienteCotizacion.email === ''){
                vm.validacionCotizacion.email = true;
                return false;
            }
            if(vm.clienteCotizacion.phone === ''){
                vm.validacionCotizacion.phone = true;
                return false;
            }
            if(vm.clienteCotizacion.cellphone === '') {
                vm.validacionCotizacion.cellphone = true;
                return false;
            }
            vm.guardaCotizacion();
            return true;
        };

        /*
         * Handler del boton Ver habitaciones
         */
        vm.scrollToBestRate = function() {
            var element = angular.element(document.getElementById('mejortarifa'));
            $document.scrollToElement(element);
            element.addClass('bg-special-success');
            $timeout(function() {
                element.removeClass('bg-special-success');
            }, 2000)
        }
        /*
        * Handler para evento click de las imagenes miniatura del caroucel
        */
        vm.changeSlide = function(index) {
            $('#carousel-hotel').carousel(index);
        }
        /*
        * handler para el evento click de las imagenes en la lista de habitaciones
        */
        vm.showModalFn = function(room, index, pos) {
            // console.log(arguments);
            vm.roomShowing = room;
            vm.showModal = true;
            $('#modal-carousel-hotel').carousel();
        }
        
        /*
        * Handler para el evento click de nombre de la habitación, cambia la imagen mostrada a al izquirda del item 
        */
        vm.changeImageContainer = function(index, pos) {
            pos.ind = index;
        }
        /*
        * Handler para el evento click del boton Reservar de la lista de habitaciones
        */
        vm.submitReservation = function(clickEvent, packageSelected) {
            vm.loaderStyle = { display: 'inline' };


            // console.log('test');
           vm.checkAvailability = true;
            var reservationData = {
                'type': 'hotel',
                'hotelCode': vm.hotel.code,
                'packageSelected': packageSelected,
                'hotelBackup': vm.hotel,
                'recotizar': vm.recotizar,
                'packageTitle': packageSelected.title,
                'searchlocalStorage': vm.searchlocalStorage
            };

            if (packageSelected.cupon) 
                reservationData.cupon = packageSelected.cupon;
        
            Cart.addToSession(reservationData).then(function(response) {
                // console.log(response.data.isAvailable);

                if(response.data.isAvailable == 0) {
                    $('#notAvailable').modal();
                    angular
                    .element(clickEvent.target)
                    .prop('disabled', false)
                    .find('i')
                    .remove();
                    vm.loaderStyle = { display: 'none' };
                } else  {
                    $window.location.href = "/hotel/reservacion";
                }

            }).catch(function(error) {

                angular
                    .element(clickEvent.target)
                    .prop('disabled', false)
                    .find('i')
                    .remove();

            });
        }

        vm.press = function($event) {
            localStorage.setItem('page', 'detalles'); 
            HotelFactory.recotizarhotel(DatosCotizador).then(function(response) {  
                // localStorage.removeItem('hotelSelected');
                window.location.reload();
            });
        }

        vm.estadoPanel = function(panel) {
             if (panel == 'opiniones') {
                vm.verOpiniones = true;
                vm.Instalacionesyserv = false;
                $("#tabinstalaciones").css("color", "#00bcf4");
                $("#tabinstalaciones").css("background", "#ffffff");
                $("#tabinstalaciones").css("text-decoration", "none");
                $("#tabopiniones").css("color", "#23527c");
                $("#tabopiniones").css("background", "#ffffff");
                $("#tabopiniones").css("text-decoration", "none");
            } else if (panel == 'Instalacionesyserv') {
                vm.Instalacionesyserv = true;
                vm.verOpiniones = false;
                $("#tabopiniones").css("color", "#00bcf4");
                $("#tabopiniones").css("background", "#ffffff");
                $("#tabopiniones").css("text-decoration", "none");
                $("#tabinstalaciones").css("color", "#23527c");
                $("#tabinstalaciones").css("background", "#ffffff");
                $("#tabinstalaciones").css("text-decoration", "none");
            } else if (panel == 'opinionesclose') {
                vm.Instalacionesyserv = true;
                vm.verOpiniones = false;
            }
        }
        
        vm.submitReservationPreview = function( packageSelected,selected, preViewSubtotal) {
            for (var addclass = 0; addclass < vm.CaroucelMovil.length; addclass++){
                if (addclass == selected){
                    $('#SelectedPackage'+addclass).removeClass('border-secondary');
                    $('#SelectedPackage'+addclass).addClass('border-primary');
                    $('#SelectedPackage'+addclass).addClass('bordersoselect');
                    $('#ButtonSelectedPackage'+addclass).html('Seleccionada');
                    $('#ButtonSelectedPackage'+addclass).removeClass('btn-outline-secondary');
                    $('#ButtonSelectedPackage'+addclass).addClass('btn-outline-primary');
                }else{
                    $('#SelectedPackage'+addclass).addClass('border-secondary');
                    $('#SelectedPackage'+addclass).removeClass('border-primary');
                    $('#SelectedPackage'+addclass).removeClass('bordersoselect');
                    $('#ButtonSelectedPackage'+addclass).html('Seleccionar');
                    $('#ButtonSelectedPackage'+addclass).removeClass('btn-outline-primary');
                    $('#ButtonSelectedPackage'+addclass).addClass('btn-outline-secondary');
                }
            }
            if (preViewSubtotal != 1){
                vm.SelectTemporalRoom = vm.CaroucelMovil[selected];
                var componentModal = angular.element('#modalBottomDetails');
                componentModal.modal('show');
                $('#modalBottomDetails').removeClass('bounceOutDown');
                $('#modalBottomDetails').addClass('bounceInUp');

                $('#toolboxdet').removeClass('d-block');
                $('#toolboxdet').addClass('d-none');
            }
        }

        /*
        * Funcion para setear el simbolo de la moneda 
        */
        vm.iconocurrency = function(currency) {
            $scope.iconocurrency = CurrencyDictionary[currency];
        }
        //Funcion para determinar iconos de facilidades
        vm.iconoFacilidades = function(icon) {
            return fontNames[icon];
        }

        vm.showModalShare = function() {
            search = localStorage.getItem('search');
            cotizadorSeleccionado = localStorage.getItem('cotizadorSeleccionado');
            hotelSelected = JSON.parse(localStorage.getItem('hotelSelected'));
        
            base = btoa(search);
            base = base + "/" + cotizadorSeleccionado + "/" + hotelSelected.code;
            $("#share-wrapp").hide();
            $("#share-load").show();
            
            $.ajax({
                type:'post',
                url:'/get/link-share',
                data: "base=" + encodeURIComponent(base),
                success: function(data){
                    localStorage.setItem('hash', data);
                    url = $("#hostdetails").val() + "share-hotel/" + data;
                    $("#share").jsSocials({
                        shares: [
                            {share: "twitter", logo: "fab fa-twitter", label: "Twitter"},
                            {share: "facebook", logo: "fab fa-facebook-f", label: "Compartir"},
                            {share: "whatsapp", logo: "fab fa-whatsapp", label: "Envía por whatsapp"},
                        ],
                        text: "",
                        url: url,
                        showLabel: true,
                        showCount: false,
                        shareIn: "popup"
                    });
                    document.getElementById("enlace").value = url;
                    $("#share-wrapp").show();
                    $("#share-load").hide();
                }
            });
        
            var element = angular.element('#ModalShare');
            element.modal('show');
        }

        vm.getlink  = function() {
            var text = document.getElementById("enlace").value;
            var textField = document.createElement('textarea');
            textField.innerText = text;
            document.body.appendChild(textField);
            textField.select();
            textField.focus(); //SET FOCUS on the TEXTFIELD
            document.execCommand('copy');
            textField.remove();
            document.getElementById("textoCopiado").innerHTML = "¡Copiado!";
            setTimeout(function(){ 
                document.getElementById("textoCopiado").innerHTML = "Copiar vínculo"
            }, 3000);
            // vm.backToTop();
        }
        
        /*
        * Filtro para imagenes de una habitacion especifica
        */
        vm.showModalDetailRoom = function(Room,DroomKey) {
            var Drooms = vm.Drooms;
            vm.DetailsRoom = {};
            var img = [];

            angular.forEach(Drooms.rooms, function (room) {

                if (room.roomCode === DroomKey) {
                    vm.DetailsRoom.Room = Room;
                    vm.DetailsRoom.roomFacilities = room.roomFacilities;

                    if (typeof room.roomStays !== 'undefined')
                        vm.roomStayFacilities = room.roomStays[0].roomStayFacilities;
                    
                    angular.forEach(room.roomFacilities, function (fa) {
                        if (fa.facilityCode == 295) {
                            vm.m2 = fa;
                        }
                    });
                    
                    angular.forEach(Drooms.images, function (images) {
                        if(images.roomCode === DroomKey){
                            img.push(images.path);
                        }
                    });
                    vm.DetailsRoom.images = img;
                }
            });
            
            var element = angular.element('#ModalDetail');
            element.modal('show');
            
        };

        $scope.filterImg = function(roomCode) {
            
            return function(img) {
              if (img.imageTypeCode === 'HAB' || img.imageTypeCode === 'GEN'){
                    if (img.imageTypeCode === 'HAB' && (img.roomType + '.' + img.characteristicCode) === roomCode) {
                        vm.modalPathActual = img.path;
                        
                        return img;
                     }else{
                       intrm=0;
                       intrm +=1;
                           if(img.imageTypeCode === "GEN" && intrm == 1){
                                vm.modalPathActual = img.path;
                                return img;
                            }else{
                                intrm = 0;
                            }                        
                    }
               } 
            }
            
        };
        
        vm.getImagesRoom = function(DroomKey) {
            var Drooms = vm.Drooms;
            var img = [];
        
            angular.forEach(Drooms.rooms, function (room) {
                if (room.roomCode === DroomKey) {                    
                    angular.forEach(Drooms.images, function (images) {
                        if(images.roomCode === DroomKey){
                            img.push(images.path);
                        }
                    });
                }
            });
            
            return img;
        };

        vm.quitarimagen = function(roomcode, index) {
            document.getElementById('noimagen_' + roomcode+"_"+index).style.display = 'none';
        }

        vm.toggleShowFullDescription = function() {
            vm.isShowingFullDescription = !vm.isShowingFullDescription;
        };

        vm.agregarACotizacion = function (package) {
            var hotelCotizacion = {};
            var autoAdapter = {};
            cotizadorSeleccionado = localStorage.getItem('cotizadorSeleccionado');
            // console.log('cotizadorSeleccionado - >', cotizadorSeleccionado);

            if(package.car != undefined && cotizadorSeleccionado == 1){
                var auto = package.car;
                autoAdapter = {
                    type: 'auto',
                    name: auto.nombreAuto,
                    description: auto.descripccion,
                    caminoImagen: auto.imagen,
                    link_imagen: auto.link_imagen,
                    proveedor: auto.id_proveedor,
                    categoryCode: auto.id_categoria,
                    categoryName: auto.categoria,
                    startDate: auto.stay.checkIn,
                    endDate: auto.stay.checkOut,
                    idDatosDirectorioAbrir: auto.id_datos_directorio_abrir,//zoneName: '',
                    idDatosDirectorioCerrar: auto.id_datos_directorio_cerrar, //destinationName: '',
                    images: [{
                        path: auto.imagen,
                        imageTypeCode: 'GEN'
                    }],
                    imagesProveedor: [{
                        path: ''
                    }],
                    price: 0,
                    content: [{
                        price: parseFloat(auto.publicRate),
                        net: auto.tarifaNeta,
                        adults: 0,
                        amount: 1,
                        tarifa: parseFloat(auto.publicRate)
                    }],
                    loaded: false,
                    cotizador: [{
                        hora_pu : "10:00",
                        hora_do : "10:00",
                        fhInicio : auto.stay.checkIn,
                        fhFin : auto.stay.checkOut,
                        ubicacion : "Aeropuerto",
                        ubicacion_do : "Aeropuerto",
                        IATA : auto.clave_destino
                    }]
                };
            }

            hotelCotizacion.code = vm.hotel.code;
            hotelCotizacion.name = vm.hotel.name;
            hotelCotizacion.categoryCode = vm.hotel.categoryCode;
            hotelCotizacion.categoryName = vm.hotel.categoryName;
            hotelCotizacion.destinationCode = vm.hotel.destinationCode;
            hotelCotizacion.destinationName = vm.hotel.destinationName;
            hotelCotizacion.zoneCode = vm.hotel.zoneCode;
            hotelCotizacion.zoneName = vm.hotel.zoneName;
            hotelCotizacion.latitude = vm.hotel.latitude;
            hotelCotizacion.longitude = vm.hotel.longitude;
            hotelCotizacion.currency = vm.hotel.currency;
            hotelCotizacion.productType = 1;
            hotelCotizacion.showConfiguration = false;
            hotelCotizacion.selectedRate = 0;
            hotelCotizacion.Recommendation = 0;
            hotelCotizacion.avgPrice = package.avgPrice;
            hotelCotizacion.price = package.price;
            hotelCotizacion.car = autoAdapter;
            hotelCotizacion.rates = [];

            hotelCotizacion.content = {
                name: vm.hotel.name,
                email: vm.hotel.content.email,
                address: vm.hotel.content.address.content,
                longitude: vm.hotel.longitude,
                latitude: vm.hotel.latitude,
                code: vm.hotel.content.code,
                destinationName: vm.hotel.destinationName,
                image: vm.hotel.content.images[0].path,
                phone: vm.hotel.content.phones[0].phoneNumber,
                zoneName: vm.hotel.zoneName,
                chain: vm.hotel.content.chainCode,
                categoryCode: vm.hotel.categoryCode,
                categoryName: vm.hotel.categoryName 
            }; 

            angular.forEach(package.rooms, function (room) {
                hotelCotizacion.rates.push({
                    code: room.roomCode,
                    name: room.roomName,
                    net: room.net,
                    publicRate: room.tarifaPublica,
                    completeName: room.roomName + ' - ' + room.boardName + ' ' + room.adults + ' Adultos - ' + room.children + ' Niños',
                    rateKey: room.rateKey,
                    reteClass: room.rateClass,
                    rateType: room.rateType,
                    allotment: room.allotment,
                    paymentType: room.paymentType,
                    packaging: room.packaging,
                    boardCode: room.boardCode,
                    boardName: room.boardName,
                    rooms: room.rooms,
                    adults: room.adults,
                    children: room.children,
                    childrenAges: room.children,
                    cancellationPolicies: room.cancellationPolicies || [],
                    promotions: room.promotions || [],
                    offers: room.offers || [],
                    dailyRates: room.dailyRates || []
                });
            });

            package.cotizacion = true;
            hotelCotizacion.pref = package;
            vm.datosCotizacion.cart.push(hotelCotizacion);
        }

        vm.disabledInputs = function ($formulario, $disable){
            var inputs = document.getElementById($formulario).elements;
            if($disable){
                for (i = 0; i < inputs.length; i++) {
                    inputs[i].setAttribute("disabled", "");
                }
            }else{
                for (i = 0; i < inputs.length; i++) {
                    inputs[i].removeAttribute("disabled");
                }
            }
        }

        vm.guardaCotizacion = function () {
            vm.disabledInputs("cotizacionForm", true);
            if (vm.cotizacionForm.$valid) {
                vm.showQuotationMesssage = false;
                vm.datosCotizacion.search = vm.search;
                vm.datosCotizacion.client = vm.clienteCotizacion;
                vm.datosCotizacion.client.lada = vm.claveInternacional;
                vm.datosCotizacion.user = (localStorage.getItem('uidFenix') != null) ? localStorage.getItem('uidFenix') : 41;
                vm.cotizacionBtn = 'Enviando <i class="fas fa-spinner fa-pulse"></i>';
                // console.log('vm.datosCotizacion - >', vm.datosCotizacion);
                HotelFactory
                    .enviaCotizacion({data: vm.datosCotizacion})
                    .then(function(response) {
                        if(response.data.success){
                            vm.cotizacionBtn = 'Guardar y enviar cotización';
                            vm.sendQuotation.msg = "Listo! La cotización ha sido enviada y guardada correctamente!";
                            vm.sendQuotation.error = false;
                            vm.datosCotizacion.search = {};
                            vm.datosCotizacion.client = {};
                            for(const key in vm.datosCotizacion.cart){
                                vm.eleminaPaqueteDeCotizacion(key);
                            }
                            vm.datosCotizacion.cart = [];
                        }
                        else{
                            vm.cotizacionBtn = 'Guardar y enviar cotización';
                            vm.sendQuotation.msg = "Oooops! La cotización no ha podido ser enviada.";
                            vm.sendQuotation.error = true;
                        }
                        vm.showQuotationMesssage = true;
                        setTimeout(() => { vm.showQuotationMesssage = false; }, 3000);
                        vm.disabledInputs("cotizacionForm", false);
                    })
                    .catch(function (error) {
                        vm.cotizacionBtn = 'Guardar y enviar cotización';
                        vm.sendQuotation.msg = "Oooops! La cotización no ha podido ser enviada.";
                        vm.sendQuotation.error = true;
                        vm.showQuotationMesssage = true;
                        setTimeout(() => { vm.showQuotationMesssage = false; }, 3000);
                        vm.disabledInputs("cotizacionForm", false);
                    });
            } else {
                // console.log('Formulario invalido');
            }
        }

        vm.eleminaPaqueteDeCotizacion = function (indice) {
            vm.datosCotizacion.cart[indice].pref.cotizacion = false;
            vm.datosCotizacion.cart.splice(indice, 1);
        }

        var arriba = 1;

        $('[data-toggle="popover"]').popover()
        
        vm.formatfecha = function(valorfecha){
            if(valorfecha !=undefined){
                var arrayfechas = valorfecha.split('-');
                switch (arrayfechas[1]) {
                    case '01': vm.messtring = 'Ene.'; break;
                    case '02': vm.messtring = 'Feb.'; break;
                    case '03': vm.messtring = 'Mar.'; break;
                    case '04': vm.messtring = 'Abr.'; break;
                    case '05': vm.messtring = 'May.'; break;
                    case '06': vm.messtring = 'Jun.'; break;
                    case '07': vm.messtring = 'Jul.'; break;
                    case '08': vm.messtring = 'Ago.'; break;
                    case '09': vm.messtring = 'Sep.'; break;
                    case '10': vm.messtring = 'Oct.'; break;
                    case '11': vm.messtring = 'Nov.'; break;
                    case '12': vm.messtring = 'Dic.'; break;
                }
                return arrayfechas[2]+' '+vm.messtring+' '+arrayfechas[0]
            }else{
                return valorfecha;
            }
        };
        vm.myAbrir = function (){            
            $("#mapaModalMapa").addClass("blockClass");
            $("#mapaModalMapa").addClass("alert-box");
            $("#contendo1").addClass("alert-back");            
            $("#cerrarModalMapa").addClass("bottom_cerrar");
            $("#contendo1").show();
            // console.log(,'tanashksa');
        }
        vm.cerrarPanel  = function(){
            $("#mapaModalMapa").removeClass("blockClass");
            $("#cerrarModalMapa").removeClass("bottom_cerrar");
            $("#mapaModalMapa").addClass("noneClass");
            $("#contendo1").hide();

        }
        setTimeout(function(){
           if($( window ).width() < 481)
                $("#contendo1").hide();
                 
            }, 9000);
           $(window).resize(function() {
                if($( window ).width() > 480){
                    $("#contendo1").show();
                    $('#footer_inf').css('display','none');
                }
                else{
                     $("#contendo1").hide();

                }
            });
        
        vm.showViewInfo=false;
        vm.verinfor = function(){
            vm.showViewInfo=!vm.showViewInfo;
            if(vm.showViewInfo == true){           
                $('#Bodyinformacion').removeClass('noneClass');     
                $('#Bodyinformacion').addClass('block_class');
                $('#footer_inf').addClass('block_class');
            }else{               
                $('#Bodyinformacion').removeClass('block_class');
                $('#footer_inf').removeClass('block_class');
                $('#Bodyinformacion').addClass('noneClass');

                
            }
            
        }

        $scope.slickConfig = {
            initialSlide:1,
            autoplay: false,
            slidesToShow: 1,
            slidesToScroll: 1,
            autoplaySpeed: 10000,
            infinite: true,
            prevArrow: '<a class="carousel-control-prev" href="#carouselExampleControls" role="button" data-slide="prev" ng-click="$ctrl.prevSlide()"><span class="carousel-control-prev-icon" aria-hidden="true"></span><span class="sr-only">Previous</span></a>',
            nextArrow: '<a class="carousel-control-next" href="#carouselExampleControls" role="button" data-slide="next" ng-click="$ctrl.nextSlide()"><span class="carousel-control-next-icon" aria-hidden="true"></span><span class="sr-only">Next</span></a>',
            touchThreshold:9,
            asNavFor: '.slidernav',
            cssEase: 'linear',
        };
        $scope.slickConfig2 = {    
            infinite: true,        
            slidesToShow: 10,
            slidesToScroll:10,  
            arrows: true,
            asNavFor: '.carouselHotel',        
            focusOnSelect: true,   
            cssEase: 'linear',
            centerMode: true,
            prevArrow: '<a class="carousel-control-prev" href="#carouselExampleControls" role="button" data-slide="prev" ng-click="$ctrl.prevSlide()"><span class="carousel-control-prev-icon" aria-hidden="true"></span><span class="sr-only">Previous</span></a>',
            nextArrow: '<a class="carousel-control-next" href="#carouselExampleControls" role="button" data-slide="next" ng-click="$ctrl.nextSlide()"><span class="carousel-control-next-icon" aria-hidden="true"></span><span class="sr-only">Next</span></a>',
        };

        $scope.slickcf = {
            initialSlide:1,
            autoplay: false,
            slidesToShow: 1,
            slidesToScroll: 1,
            autoplaySpeed: 10000,
            infinite: true,
            prevArrow: '<a class="carousel-control-prev" href="#carouselExampleControls" role="button" data-slide="prev" ng-click="$ctrl.prevSlide()"><span class="carousel-control-prev-icon" aria-hidden="true"></span><span class="sr-only">Previous</span></a>',
            nextArrow: '<a class="carousel-control-next" href="#carouselExampleControls" role="button" data-slide="next" ng-click="$ctrl.nextSlide()"><span class="carousel-control-next-icon" aria-hidden="true"></span><span class="sr-only">Next</span></a>',
            touchThreshold:9,
            asNavFor: '.slidernav2',
            cssEase: 'linear',
        };

        vm.enableCarousel = function (event, data) {
            if($(event.currentTarget).siblings('.carousel-imageRoom-inner').children().length == 1){
                let template = '';
                data.forEach(function(item, index) {
                    template += '<div class="carousel-item '+(index == 0 ? 'active' : '')+'" style="height: auto !important;">'+
                        '<img src="'+vm.pathImagesNormal+'/'+item+'" class="img-fluid d-block w-100">'+
                    '</div>';
                });
        
                $(event.currentTarget).siblings('.carousel-imageRoom-inner').html(template);
            }
        }

    }

    $(document).ready(function() {
        $(window).scroll(function() {
            $distancia = $("#mainMenu").height();
            $distancia2 = $(window).scrollTop();
            if ($distancia2 >= '200') {
                if(elem = document.getElementById('menu-oculto'))
                    elem.style.display = 'block';
            } else {
                if(elem = document.getElementById('menu-oculto'))
                    {
                        elem.style.display = 'none';
                }
            }
        });
    });
})();
